// extracted by mini-css-extract-plugin
export default {"products":"Ku-z","card":"Lu-z","oosMessaging":"Mu-z"};